import Phaser from 'phaser';
import { TILE, PlayerId } from '../types';
import { fitStaticBodyToTile } from '../systems/SpriteScaling';

export const BOMB_FUSE_MS = 3000;

export class Bomb extends Phaser.Physics.Arcade.Sprite {
  readonly ownerId: PlayerId;
  readonly range: number;
  readonly pierce: boolean;
  readonly col: number;
  readonly row: number;
  readonly remote: boolean;
  private exploded = false;
  private fuseTimer?: Phaser.Time.TimerEvent;
  private onExplode: (bomb: Bomb) => void;

  constructor(
    scene: Phaser.Scene,
    col: number,
    row: number,
    ownerId: PlayerId,
    range: number,
    pierce: boolean,
    remote: boolean,
    onExplode: (b: Bomb) => void,
  ) {
    const x = col * TILE + TILE / 2;
    const y = row * TILE + TILE / 2;
    super(scene, x, y, 'bomb');
    this.col = col;
    this.row = row;
    this.ownerId = ownerId;
    this.range = range;
    this.pierce = pierce;
    this.remote = remote;
    this.onExplode = onExplode;
    if (remote) this.setTint(0x52ff7a);
    scene.add.existing(this);
    scene.physics.add.existing(this, true);
    fitStaticBodyToTile(this, TILE - 8, TILE - 8);

    // Subtle pulse (operates on scale so the static body stays put)
    const base = this.scaleX;
    scene.tweens.add({
      targets: this,
      scaleX: { from: base * 0.9, to: base * 1.05 },
      scaleY: { from: base * 0.9, to: base * 1.05 },
      yoyo: true,
      repeat: -1,
      duration: remote ? 600 : 400,
    });

    if (!remote) {
      this.fuseTimer = scene.time.delayedCall(BOMB_FUSE_MS, () => this.explode());
    }
  }

  explode() {
    if (this.exploded) return;
    this.exploded = true;
    this.fuseTimer?.remove();
    this.onExplode(this);
  }

  triggerChain() {
    // Used by remote detonation or chain-reaction
    if (!this.exploded) this.explode();
  }
}
